import {init} from 'hiya-common/src/entry/index'

import getRoutes from '~/routes'
import {createStore} from '~/stores'

import projectConfig from '../../config'

init({
  getRoutes,
  createStore,
  projectConfig,
})
